<template>
    <div class="mypage">
      <router-view :key="key"></router-view>        
    </div>
</template>

<script>
export default {
    name:'layout',
    components: {},
    computed: {
    key() {
      return this.$route.fullPath
    }
  }
}
</script>
<style scoped>
.mypage{
  margin-top:-80px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout_empty.vue